import Axios from "axios";
import { EDIT_CLIENT_DATA } from "../../types";
import ToastMessage from '../../../components/toast';


export const updateClient = (vals) => async (dispatch) => {
  let client = await Axios.post(`api/clients/client`, { ...vals });

  dispatch({ type: EDIT_CLIENT_DATA, payload: client.data.data });
  ToastMessage("Successfully submitted", "success");
};

/* export const getClient = (company) => async (dispatch) => {
  let client = await Axios.post(`api/clients/client/${company}`);

  dispatch({ type: GET_CLIENT, payload: client.data.data });
};
 */